/* global CONFIG */
import moment from 'moment'
import services from '../services'

export default {
  updateRsvp (VueApp, params, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + params.rsvpId, params, res => {
      callback(res)
    })
  },
  getQuote2 (VueApp, params, callback) {
    let self = this
    if (!params.isCharter) {
      params.order = 'priority'
    }
    let rsvpDetails = VueApp.$store.state.rsvpDetails
    let originalRsvp = rsvpDetails.basicInfo.tripInfo
    let editedRsvp = rsvpDetails.edit.details.tripInfo

    let isPickupSame = false
    if ((originalRsvp.pickup.geofenceType === 'airport' && originalRsvp.pickup.geofenceId === editedRsvp.pickup.geofenceId) ||
      (originalRsvp.pickup.geofenceType !== 'airport' && originalRsvp.pickup.title === editedRsvp.pickup.title)
    ) {
      isPickupSame = true
    }

    let isDropoffSame = false
    if ((originalRsvp.dropoff.geofenceType === 'airport' && originalRsvp.dropoff.geofenceId === editedRsvp.dropoff.geofenceId) ||
    (originalRsvp.dropoff.geofenceType !== 'airport' && originalRsvp.dropoff.title === editedRsvp.dropoff.title)
    ) {
      isDropoffSame = true
    }
    if (!rsvpDetails.isAdd && originalRsvp.serviceTypeId <= 5 && isPickupSame && isDropoffSame) {
      VueApp.$sdk.post('/reservations/' + params.pickupDate, params, res => {
        let extraService = {}
        if (!res.error) {
          for (let service in res.services) {
            if (res.services[service].code === originalRsvp.serviceCode) {
              extraService = {
                code: originalRsvp.serviceCode,
                value: {
                  id: res.services[service].id,
                  code: res.services[service].code,
                  name: services.getServiceName(res.services[service].code),
                  maxLuggage: res.services[service].maxLuggage,
                  maxPassengers: res.services[service].maxPassengers,
                  curbside: res.services[service].curbside,
                  meetAndGreet: res.services[service].meetAndGreet,
                  pickupFee: res.services[service].pickupFee,
                  prices: res.services[service].oneway,
                  status: res.services[service].status,
                  airportFee: res.services[service].airportFee,
                  travelInsurance: res.services[service].travelInsurance,
                  isShared: res.services[service].code === 'shared',
                  defaultTip: 0
                }
              }
            }
          }
          self.getNewQuote(VueApp, params, extraService, callback)
        } else {
          self.getNewQuote(VueApp, params, false, callback)
        }
      })
    } else {
      if (params.isCharter) {
        self.getCharterQuote(VueApp, params, callback)
        return
      }
      self.getNewQuote(VueApp, params, false, callback)
    }
  },
  getNewQuote (VueApp, params, extraService, callback) {
    let self = this
    params.isAdmin = true

    // Mtech adds
    let rsvpStore = VueApp.$store.state.rsvpDetails
    let rsvpEdit = VueApp.$store.state.rsvpDetails.edit.details.tripInfo
    params.pickup.text = rsvpEdit.pickup.title
    params.dropoff.text = rsvpEdit.dropoff.title
    params.passengers = rsvpEdit.passenger || 1
    if (rsvpStore.mtech.flightDate) {
      params.pickupTimestamp = moment.tz(rsvpStore.mtech.flightDate, 'MM/DD/YYYY hh:mmA', rsvpStore.edit.timezone).format('X')
    } else {
      params.pickupTimestamp = moment.tz(`${params.pickupDate} ${params.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpStore.edit.timezone).format('X')
    }

    if (params.asap) {
      self.getLyftAsap(VueApp, params, callback)
      return
    }

    let usa = ['us', 'usa', 'united states', 'united states of america']
    let canada = ['can', 'ca', 'canada']
    let ca = ['ca', 'california']
    let brand = CONFIG.brands.find(x => x.id === params.brandId)
    if (brand.code === 'd2d' && params.pickup.country &&
      (
        (usa.indexOf(params.pickup.country.toLowerCase()) > -1 && params.pickup.state && ca.indexOf(params.pickup.state.toLowerCase()) === -1) ||
        (canada.indexOf(params.pickup.country.toLowerCase()) > -1)
      )
    ) {
      self.lyftQuoteCheck(VueApp, params, callback)
      return
    }

    let timeNow = moment()
    VueApp.$sdk.post('/quotation', params, res => {
      self.sendQuoteTime(VueApp, timeNow, moment(), res.quoteId, params.brandId)
      let mtech = res.mtech
      VueApp.$store.commit('rsvpDetails/setMtechData', {enabled: typeof mtech === 'object'})

      if (res.error ||
        (brand.code === 'd2d' &&
          ((
            res.geofences &&
            params.pickup.country && usa.indexOf(params.pickup.country.toLowerCase()) > -1 &&
            ca.indexOf(params.pickup.state.toLowerCase()) > -1 &&
            !res.geofences.servicearea.name.includes('LAX')
          ) ||
          (
            res.geofences &&
            params.pickup.country && usa.indexOf(params.pickup.country.toLowerCase()) > -1 &&
            ca.indexOf(params.pickup.state.toLowerCase()) === -1
          ) ||
          (!params.asap && params.pickup.country && canada.indexOf(params.pickup.country.toLowerCase()) > -1)
        ))
      ) {
        self.lyftQuoteCheck(VueApp, params, callback)
        return
      }
      if (brand.code !== 'd2d' && !params.asap && !params.isCharter && !params.extraStops && ((res.services && !res.services.length && !res.mtech) || (res.mtech && !res.mtech.services.length))) {
        self.lyftQuoteCheck(VueApp, params, callback)
        return
      }
      VueApp.$store.commit('rsvpDetails/setLyftData', {enabled: false})

      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/setDistanceEta', {
          distance: res.route.distance,
          eta: res.route.eta.sec
        })

        let services = {}
        if (!mtech) {
          res.services.forEach(service => {
            let availTimeStart = ''
            let availTimeEnd = ''
            let timeSelected = ''
            let serviceUnavailable = service.serviceType.unavailableTime
            let unavailableService = false
            if (
              (serviceUnavailable.p2p || serviceUnavailable.fromAirport || serviceUnavailable.toAirport) &&
              serviceUnavailable.start !== serviceUnavailable.end &&
              ((params.asap && serviceUnavailable.asap) || (!params.asap && serviceUnavailable.future))
            ) {
              availTimeStart = moment(serviceUnavailable.start, 'H')
              availTimeEnd = moment(serviceUnavailable.end, 'H')
              timeSelected = moment(params.pickupTime, 'HH:mm')
              if (
                (serviceUnavailable.end >= serviceUnavailable.start && timeSelected.isBetween(availTimeStart, availTimeEnd, null, '[]')) ||
                (serviceUnavailable.start >= serviceUnavailable.end && !timeSelected.isBetween(availTimeEnd, availTimeStart, null, '()'))
              ) {
                if (
                  (serviceUnavailable.p2p && res.geofences.pickup.type !== 'airport' && res.geofences.dropoff.type !== 'airport') ||
                  (serviceUnavailable.fromAirport && res.geofences.pickup.type === 'airport') ||
                  (serviceUnavailable.toAirport && res.geofences.dropoff.type === 'airport')
                ) {
                  unavailableService = true
                }
              }
              if (rsvpStore.edit.selectedService === `a${service.serviceType.id}` && unavailableService) {
                VueApp.$store.commit('rsvpDetails/setSelectedService', '')
              }
            }

            let curbside = false
            let meetAndGreet = false
            let pickupFee = 0
            if (service.pickupTypes.length) {
              let curbsideIndex = service.pickupTypes.findIndex(x => x.name === 'Curbside')
              let meetAndGreetIndex = service.pickupTypes.findIndex(x => x.name === 'MeetAndGreet')
              if (curbsideIndex > -1) {
                curbside = service.pickupTypes[curbsideIndex].enabled
              }
              if (meetAndGreetIndex > -1) {
                meetAndGreet = service.pickupTypes[meetAndGreetIndex].enabled
                pickupFee = service.pickupTypes[meetAndGreetIndex].fee
              }
            }
            if (!service.settings.discountAdmin) {
              service.oneway.forEach((price, i) => {
                service.oneway[i].discount = 0
                service.oneway[i].price = price.original
              })
            }
            services['a' + service.serviceType.id] = {
              id: service.serviceType.id,
              code: 'a' + service.serviceType.id,
              name: service.serviceType.name,
              maxLuggage: service.serviceType.maxLuggages,
              maxPassengers: service.serviceType.maxPassengers,
              curbside: curbside,
              meetAndGreet: meetAndGreet,
              pickupFee: pickupFee,
              prices: service.oneway,
              status: 'allowed',
              airportFee: service.settings.airportFee,
              travelInsurance: service.settings.travelInsurance,
              isShared: service.serviceType.isShared,
              licenseType: service.serviceType.licenseType,
              availability: service.availability,
              defaultTip: service.serviceType.defaultTip,
              gasFee: service.settings.gasFee || 0,
              optinAllow: service.serviceType.optinAllow,
              optinPercent: service.serviceType.optinPercent || 1,
              unavailableTime: service.unavailableTime,
              bufferTime: service.serviceType.bufferAdminMins,
              unavailableService: unavailableService,
              portalFee: service.settings.portalFee,
              portalFeeType: service.settings.portalFeeType
            }
            if (!service.serviceType.bufferAdminMins && VueApp.$store.state.settings.adminTimeBuffer) {
              services['a' + service.serviceType.id].bufferTime = VueApp.$store.state.settings.adminTimeBuffer
            }
            // if (service.serviceType.isShared) {
              // VueApp.$store.commit('rsvpDetails/addSharedService', services['a' + service.serviceType.id])
              // delete services['a' + service.serviceType.id]
            // }
          })
          VueApp.$store.commit('rsvpDetails/setServices', services)
          if (extraService && Object.keys(extraService).length > 0) {
            VueApp.$store.commit('rsvpDetails/addService', extraService)
          }
        } else {
          VueApp.$store.commit('rsvpDetails/setMtechData', {quoteId: res.quoteId})
          let mtechStore = rsvpStore.mtech
          mtech.services.forEach(service => {
            let product = service.product
            let info = service.info
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            let pax = { label: '', value: 1 }
            let luggage = { label: '', value: 0 }
            let cxl = ''
            let pircePax = ''
            info.forEach(inf => {
              if (inf && inf.toLowerCase().indexOf('max passenger') > -1) {
                pax = {
                  label: inf,
                  value: parseInt(inf.split(' ')[inf.split(' ').length - 1]) || 1
                }
              }
              if (inf && inf.toLowerCase().indexOf('max bag') > -1) {
                luggage = {
                  label: inf,
                  value: parseInt(inf.split(' ')[inf.split(' ').length - 1]) || 1
                }
              }
              if (inf && inf.toLowerCase().indexOf('24 hour cancelation') > -1) {
                cxl = inf
              }
              if (inf && inf.toLowerCase().indexOf('price includes all') > -1) {
                pircePax = inf
              }
            })
            services[service.product.code] = {
              uid: product.uid,
              category: product.category,
              code: product.code,
              desc: product.description || product.name,
              img: product.image,
              name: product.name,
              maxPax: pax.label,
              maxPaxVal: pax.value,
              maxLuggage: luggage.label,
              maxLuggageVal: luggage.value,
              cancellation: cxl,
              pricePax: pircePax,
              price: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              },
              pickupTimes: service.pickupTimes,
              product: product
            }
          })
          if (params.extraStops && params.extraStops.length) {
            services = []
          }
          VueApp.$store.commit('rsvpDetails/setMtechData', {services: services})
        }

        if (res.geofences.pickup.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.pickup.code)
        } else if (res.geofences.dropoff.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.dropoff.code)
        }
      }
      callback(res)
    }, '2.0')
  },
  getQuote (VueApp, params, callback) {
    let self = this
    VueApp.$sdk.post('/reservations/' + params.date, params, res => {
      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/setDistanceEta', {
          distance: res.route.distance,
          eta: res.route.eta.sec
        })
        let services = res.services
        VueApp.$store.commit('rsvpDetails/setServices', {
          shared: self.buildServiceData(services.Shared),
          opoli: self.buildServiceData(services.Opoli),
          black: self.buildServiceData(services.Black),
          suv: self.buildServiceData(services.SUV),
          shuttle: self.buildServiceData(services['Private Shuttle'])
        })

        VueApp.$store.commit('rsvpDetails/setHoliday', {
          date: res.geofences.pricing.holidayDate,
          shared: {
            currency: res.geofences.pricing.pricing.SharedHolidayRateCurrency,
            value: res.geofences.pricing.pricing.SharedHolidayRate
          },
          opoli: {
            currency: res.geofences.pricing.pricing.OpoliHolidayRateCurrency,
            value: res.geofences.pricing.pricing.OpoliHolidayRate
          },
          black: {
            currency: res.geofences.pricing.pricing.BlackHolidayRateCurrency,
            value: res.geofences.pricing.pricing.BlackHolidayRate
          },
          suv: {
            currency: res.geofences.pricing.pricing.SUVHolidayRateCurrency,
            value: res.geofences.pricing.pricing.SUVHolidayRate
          },
          shuttle: {
            currency: res.geofences.pricing.pricing.PrivateShuttleHolidayRateCurrency,
            value: res.geofences.pricing.pricing.PrivateShuttleHolidayRate
          }
        })

        if (res.geofences.pickup.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.pickup.airportCode)
        } else if (res.geofences.dropoff.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.dropoff.airportCode)
        }
      }

      callback(res)
    })
  },
  getUserList (VueApp, params, callback) {
    VueApp.$sdk.get('/consumer', {
      token: VueApp.$store.state.session.sessionToken,
      search: params.search,
      pageNum: params.pageNum + 1,
      pageSize: params.pageSize
    }, res => {
      VueApp.$store.commit('rsvpDetails/setUserPageNum', params.pageNum + 1)

      let users = []
      res.list.forEach(function (user) {
        users.push({
          id: user.ID,
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.phone || '',
          email: user.email
        })
      })
      VueApp.$store.commit('rsvpDetails/setUserList', users)
      callback(res)
    })
  },
  buildServiceData (data) {
    let prices = []
    for (let i = 0; i < data.maxPassengers; i++) {
      prices.push(data.oneway[i])
    }

    return {
      id: data.id,
      code: data.code,
      maxLuggage: data.maxLuggage,
      maxPassengers: data.maxPassengers,
      curbside: data.curbside,
      meetAndGreet: data.meetAndGreet,
      pickupFee: data.pickupFee,
      prices: prices,
      status: data.status,
      airportFee: data.airportFee,
      travelInsurance: data.travelInsurance,
      portalFee: data.portalFee || 0,
      portalFeeType: data.portalFeeType
    }
  },
  getCharterQuote (VueApp, params, callback) {
    let self = this
    let timeNow = moment()
    VueApp.$sdk.post('/quotation/charter', params, res => {
      self.sendQuoteTime(VueApp, timeNow, moment(), res.quoteId, params.brandId)
      if (!res.error) {
        // VueApp.$store.commit('rsvpDetails/setDistanceEta', {
        //   distance: res.route.distance,
        //   eta: res.route.eta.sec
        // })

        let services = {}
        res.services.forEach(service => {
          let curbside = false
          let meetAndGreet = false
          let pickupFee = 0
          if (service.pickupTypes.length) {
            let curbsideIndex = service.pickupTypes.findIndex(x => x.name === 'Curbside')
            let meetAndGreetIndex = service.pickupTypes.findIndex(x => x.name === 'MeetAndGreet')
            if (curbsideIndex > -1) {
              curbside = service.pickupTypes[curbsideIndex].enabled
            }
            if (meetAndGreetIndex > -1) {
              meetAndGreet = service.pickupTypes[meetAndGreetIndex].enabled
              pickupFee = service.pickupTypes[meetAndGreetIndex].fee
            }
          }
          let price = []
          for (let x = 0; x < service.serviceType.maxPassengers; x++) {
            price.push(service.fare)
          }
          services['a' + service.serviceType.id] = {
            id: service.serviceType.id,
            code: 'a' + service.serviceType.id,
            name: service.serviceType.name,
            maxLuggage: service.serviceType.maxLuggages,
            maxPassengers: service.serviceType.maxPassengers,
            curbside: curbside,
            meetAndGreet: meetAndGreet,
            pickupFee: pickupFee,
            prices: price,
            status: 'allowed',
            airportFee: service.settings.airportFee,
            travelInsurance: service.settings.travelInsurance || 0,
            isShared: service.serviceType.isShared,
            licenseType: service.serviceType.licenseType,
            availability: service.availability || null,
            defaultTip: service.serviceType.defaultTip,
            portalFee: service.settings.portalFee,
            portalFeeType: service.settings.portalFeeType
          }
        })
        VueApp.$store.commit('rsvpDetails/setServices', services)

        if (res.airport && res.airport.id) {
          VueApp.$store.commit('rsvpDetails/setAirportCode',  res.airport.airportCode || 'LAX')
        }
      }
      callback(res)
    }, '2.0')
  },
  sendQuoteTime (VueApp, start, end, quoteId, brandId) {
    let store = VueApp.$store.state
    let duration = end.diff(start, 'milliseconds') / 1000
    VueApp.$sdk.opt('/quotation/time', {
      token: store.session.sessionToken,
      brandId: brandId,
      quotationId: quoteId,
      responseTime: duration,
      deviceType: 'admin'
    }, res => {
      if (res.error) console.log('ERROR quotation time')
    })
  },
  getLyftAsap (VueApp, param, callback) {
    let self = this
    VueApp.$sdk.post('/quotation/asap', param, res => {
      self.buildLyftService(VueApp, param, res, callback)
    }, '2.0')
  },
  buildLyftService (VueApp, param, res, callback) {
    if (res.lyft) {
      let hasService = false
      res.lyft.forEach(x => {
        if (x.can_request_ride) hasService = true
      })
      if (!hasService) res.lyft = []
    }

    let services = {}
    if ((res.lyft && !res.lyft.length) || res.error) {
      if (!res.error) res.error = {}
      else {
        console.log(1)
        callback(res)
        return
      }
    } else {
      VueApp.$store.commit('rsvpDetails/setLyftData', {enabled: true})
      VueApp.$store.commit('rsvpDetails/setDistanceEta', {
        distance: res.route.distance,
        eta: res.route.eta.sec
      })
      res.lyft.forEach(service => {
        let curbside = false
        let meetAndGreet = false
        let pickupFee = 0
        let price = (service.estimated_cost_cents_max / 100).toFixed(2)
        let maxPax = service.price_explanation_text ? service.price_explanation_text.replace(/^\D+/g, '') : 4
        if (maxPax) maxPax = parseInt(maxPax)
        if (!maxPax) maxPax = 4
        let pricesArray = [{
          discount: 0,
          distance: service.estimated_distance_miles,
          original: parseFloat(price),
          price: parseFloat(price),
          passengers: 1
        }]
        for (var c = 1; c < maxPax; c++) {
          pricesArray.push(pricesArray[0])
        }
        services['a' + service.ride_type] = {
          id: service.ride_type,
          code: 'a' + service.ride_type,
          name: service.display_name,
          maxLuggage: maxPax,
          maxPassengers: maxPax,
          curbside: curbside,
          meetAndGreet: meetAndGreet,
          pickupFee: pickupFee,
          prices: pricesArray,
          status: 'allowed',
          airportFee: 0,
          travelInsurance: 0,
          isShared: false,
          licenseType: '',
          availability: null,
          defaultTip: 0,
          gasFee: 0,
          optinAllow: false,
          optinPercent: 1,
          unavailableTime: false,
          bufferTime: 0,
          unavailableService: false,
          portalFee: 0,
          portalFeeType: '$',
          ride_type: service.ride_type,
          cost_token: service.cost_token,
          driver_availability_token: service.driver_availability_token || ''
        }
        // if (!service.serviceType.bufferAdminMins && VueApp.$store.state.settings.adminTimeBuffer) {
        //   services['a' + service.serviceType.id].bufferTime = VueApp.$store.state.settings.adminTimeBuffer
        // }
      })
      VueApp.$store.commit('rsvpDetails/setServices', services)

      // if (res.geofences.pickup.type === 'airport') {
      //   VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.pickup.code)
      // } else if (res.geofences.dropoff.type === 'airport') {
      //   VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.dropoff.code)
      // }
      VueApp.$store.commit('rsvpDetails/setAirportCode', '')
    }
    VueApp.$store.commit('rsvpDetails/setServices', services)

    callback(res)
  },
  lyftQuoteCheck (VueApp, param, callback) {
    let self = this
    let newParam = {
      brandId: param.brandId,
      pickup: param.pickup,
      dropoff: param.dropoff,
      pickupTime: moment(param.pickupDate, 'YYYY-MM-DD').format('X')
    }

    VueApp.$store.commit('rsvpDetails/setSelectedService', '')
    VueApp.$sdk.post('/quotation/lyft/future', newParam, res => {
      self.buildLyftService(VueApp, param, res, callback)
    }, '2.0')
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/reservation-details/edit.js